import { useEffect, useState } from 'react';

const getDeviceType = size => {
  if (!size) return;
  // eslint-disable-next-line no-nested-ternary
  return size >= 1100 ? 'full' : size < 1100 && size > 900 ? 'tablet' : 'mobile';
};

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
    type: null,
  });
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        type: getDeviceType(window.innerWidth),
      });
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
};
